import { Stack, TextField } from '@mui/material';
import { Button, colors } from '@sweep-io/sweep-design';
import { useRef, useEffect } from 'react';

interface CategoryFormProps {
  name: string;
  description: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  shouldFocus?: boolean;
}

export const CategoryForm = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  onSubmit,
  onCancel,
  shouldFocus = false,
}: CategoryFormProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (shouldFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [shouldFocus]);

  return (
    <Stack gap={1} pt={1} sx={{ borderBottom: '1px solid', borderColor: colors.grey[300] }}>
      <TextField
        inputRef={inputRef}
        placeholder="Add title"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit();
          } else if (e.key === 'Escape') {
            onCancel();
          }
        }}
      />
      <TextField
        placeholder="Add description"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit();
          } else if (e.key === 'Escape') {
            onCancel();
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap={1} pt={1} pb={2}>
        <Button variant="secondary" size="tiny" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="tiny" onClick={onSubmit} disabled={!name.trim()}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
